<div class="container-fluid">
    <h1 style="font-family: 'Acumin Variable Concept' !important;font-size: 25px;margin:5px 10px;">History</h1>
    <div class="sub-container">
        <div *ngIf="loading" class="wrapper">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="shadow"></div>
            <div class="shadow"></div>
            <div class="shadow"></div>
            <span>Loading</span>
        </div>
        
        <p *ngIf="!loading && caregiver"> <ag-grid-angular  
                [gridOptions]="gridOptions"
                style="width:inherit" 
                class="ag-theme-alpine"
                [rowData]="rowData"
                [pagination] ="true"
                (gridReady)="onGridReady($event)"
                [paginationPageSize]="paginationPageSize"
                [suppressExcelExport]="true"
                [columnDefs] ="columnDefs"
                [domLayout] ="domLayout"
                >
            </ag-grid-angular></p>
            <p *ngIf="!loading && recruiter"> <ag-grid-angular  
                [gridOptions]="gridOptions"
                style="width:inherit" 
                class="ag-theme-alpine"
                [rowData1]="rowData1"
                [pagination] ="true"
                (gridReady)="onGridReady1($event)"
                [paginationPageSize]="paginationPageSize1"
                [suppressExcelExport]="true"
                [columnDefs] ="columnDefs1"
                [domLayout] ="domLayout"
                >
            </ag-grid-angular></p>
        </div>
    </div>